import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {WhStockRequestedModel} from '../../../models/loads/wh-stock-requested.model';
import {LoadsService} from '../../../services/loads/loads.service';
import {StatusHistoryModel} from '../../../models/status-history.model';
import * as moment from "moment";

@Component({
  selector: 'app-orders-request',
  templateUrl: './orders-request.component.html',
  styleUrls: ['./orders-request.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class OrdersRequestComponent implements OnInit {

    whForwardings: any[] = [];
    startDate: Date;
    endDate: Date;
    referenceNo: string;
    code: string;
    imageDisplay: boolean = false;
    photoData: string = null;
    statusHistoryDialog: boolean = false;
    statusHistoryDTOs: StatusHistoryModel[] = [];

    constructor(private loadService: LoadsService) {}

    ngOnInit() {
      const date = new Date();
      this.startDate = new Date(date.getFullYear(), date.getMonth(), 1);
      this.endDate = new Date(date.getFullYear(), date.getMonth() + 1, 0);

      this.getRequests();
    }

    async getWhForwarding(whForwarding: any) {
        whForwarding.whForwardingModel = await this.loadService.getWhForwarding(whForwarding.id).toPromise();
        if (whForwarding?.whForwardingModel?.products) {
            whForwarding.whForwardingModel.products = Object.values(
                whForwarding.whForwardingModel.products.reduce((acc, product) => {
                    const id = product.whProduct.id;

                    const quantity = product.quantity; // Sayısal toplama garanti altına alınır
                    console.log(product.quantity,quantity)
                    if (acc[id]) {
                        acc[id].quantity += quantity;
                    } else {
                        // Orijinal objeyi bozmamak için kopyasını alıyoruz
                        acc[id] = { ...product, quantity: quantity };
                        console.log(product.quantity,quantity,acc[id])
                    }

                    return acc;
                }, {})
            );
        }
        console.log(whForwarding)
    }


    async getRequests() {
            this.whForwardings = await this.loadService.getWhForwardingsByAllStatus(this.startDate ? moment(this.startDate, 'MM-DD-YYYY').utc().format("YYYY-MM-DDT00:00:00.000") : null, this.endDate ? moment(this.endDate, 'MM-DD-YYYY').utc(true).format("YYYY-MM-DDT23:59:59.999") : null,this.referenceNo,this.code).toPromise();
    }

    showDialog(photoData) {
        if (photoData) {
            this.photoData = photoData;
            this.imageDisplay = true;
        }
    }
}
